var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShengsuo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 678",
    d: "M2 9.75L8.5625 2.25L15.125 9.75",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 679",
    d: "M4.8125 9.87503L8.5625 5.57144L12.2344 9.79691",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 58",
    x1: 1.03125,
    y1: 9.78125,
    x2: 16.4688,
    y2: 9.78125,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 59",
    x1: 8.5625,
    y1: 0.28125,
    x2: 8.5625,
    y2: 15.7188,
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShengsuo);
export default __webpack_public_path__ + "static/media/shengsuo.b5d1bdd93f2b01c85552b651f4b47706.svg";
export { ForwardRef as ReactComponent };